import Mandarin from "./ch/translation.json";
import English from "./en/translation.json";
import French from "./fr/translation.json";
import i18next from "i18next";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    en: {
      translation: English,
    },
    ch: {
      translation: Mandarin,
    },
    fr: {
      translation: French,
    },
  },
});

export default i18next;
